import initWordWidget from './words'

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', () => {
    initWordWidget()
  })
} else {
  initWordWidget()
}
